import { Badge } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  title: string;
  count: number;
  showCount: boolean;
};

const SearchResultsHeader: FC<Props> = ({ title, count, showCount }) => (
  <div className="flex items-center justify-between">
    <h3 className="text-xl font-semibold">{title}</h3>
    {showCount && (
      <Badge variant="secondary" className="h-6">
        {count}
      </Badge>
    )}
  </div>
);

export default SearchResultsHeader;
